import React from 'react'
import { connect } from 'react-redux'
import imgFeatureList1 from '../../images/public/users.png'
import imgFeatureList2 from '../../images/public/star.png'
import imgFeatureList3 from '../../images/public/badge.png'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import SupportList from '../partials/SupportList.jsx'
import CallToActRegister from '../partials/CallToActRegister.jsx'
import BlogList from '../partials/BlogList.jsx'

class ArticlesCampuses extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {

    return (
			<main>
      <section className="homepage-feature">
				<Header isNavbarFixed={true} />
				<div className="homepage-feature-list bg-campuses">
          <div className="container">
            <h2 className="heading1 m-b-76">Astronaut for Campus Hiring</h2>
            <div className="flex flex-around">
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList1} alt="More talent, from more schools" />
                </div>
                <div className="heading4 bold">
									MORE TALENT, <br />FROM MORE SCHOOLS
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList2} alt="Build your brand strong" />
								</div>
                <div className="heading4 bold">
                  BUILD YOUR BRAND STRONG
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList3} alt="Find true potential fast" />
								</div>
                <div className="heading4 bold">
                  FIND TRUE POTENTIAL FAST
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
			<section className="article-page-title">
				<div className="heading2">Case Study</div>
				<div className="heading1 larger">Contact us for more details.</div>
			</section>
      <SupportList />
      <CallToActRegister />
			<BlogList />
      <Footer />
    </main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesCampuses)
